import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import environment from "setup/environment";

import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

Amplify.configure({
  Auth: {
    region: environment.USER_POOL_REGION,
    userPoolId: environment.USER_POOL_ID,
    userPoolWebClientId: environment.USER_POOL_WEB_CLIENT_ID,
  },
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
